/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconCashback8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCashback8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.242.916a1.324 1.324 0 1 0 0 2.648 1.324 1.324 0 0 0 0-2.648ZM1.555 2.24a.687.687 0 1 1 1.374 0 .687.687 0 0 1-1.374 0Z"
                fill="currentColor"
            />
            <path d="m6.787 1.664-.45-.45-5.122 5.121.45.45 5.122-5.121Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.76 4.435a1.324 1.324 0 1 0 0 2.648 1.324 1.324 0 0 0 0-2.648Zm-.686 1.324a.687.687 0 1 1 1.374 0 .687.687 0 0 1-1.374 0Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconCashback12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCashback12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.36 1.375a1.986 1.986 0 1 0 0 3.971 1.986 1.986 0 0 0 0-3.971ZM2.33 3.361a1.03 1.03 0 1 1 2.061 0 1.03 1.03 0 0 1-2.06 0Z"
                fill="currentColor"
            />
            <path d="m10.18 2.496-.676-.675L1.82 9.504l.675.675 7.683-7.683Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.64 6.654a1.986 1.986 0 1 0 0 3.971 1.986 1.986 0 0 0 0-3.971ZM7.608 8.639a1.03 1.03 0 1 1 2.06 0 1.03 1.03 0 0 1-2.06 0Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconCashback16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCashback16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.48 1.834a2.648 2.648 0 1 0 0 5.295 2.648 2.648 0 0 0 0-5.295ZM3.106 4.482a1.374 1.374 0 1 1 2.748 0 1.374 1.374 0 0 1-2.748 0Z"
                fill="currentColor"
            />
            <path d="m13.57 3.329-.9-.9L2.426 12.671l.901.9L13.571 3.33Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.518 8.872a2.648 2.648 0 1 0 0 5.295 2.648 2.648 0 0 0 0-5.295Zm-1.374 2.648a1.374 1.374 0 1 1 2.748 0 1.374 1.374 0 0 1-2.748 0Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconCashback24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCashback24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.721 2.75a3.971 3.971 0 1 0 0 7.943 3.971 3.971 0 0 0 0-7.943Zm-2.06 3.971a2.061 2.061 0 1 1 4.122 0 2.061 2.061 0 0 1-4.123 0Z"
                fill="currentColor"
            />
            <path d="m20.358 4.993-1.35-1.351L3.642 19.008l1.35 1.35L20.358 4.993Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.279 13.307a3.971 3.971 0 1 0 0 7.943 3.971 3.971 0 0 0 0-7.943Zm-2.062 3.972a2.061 2.061 0 1 1 4.123 0 2.061 2.061 0 0 1-4.123 0Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconCashback = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCashback(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconCashback8 {...iconProps} />;
        case '12':
            return <IconCashback12 {...iconProps} />;
        case '16':
            return <IconCashback16 {...iconProps} />;
        case '24':
            return <IconCashback24 {...iconProps} />;
        default:
            return <IconCashback24 {...iconProps} />;
    }
});
